import { tone } from './shared.js';
import { drawLawn } from './lawn-art.js';

export const TOOLS = [
  { name: 'Weed eater', short: 'TRIM', color: '#ef8755', speed: 64, range: 19, kinds: ['edge', 'bush'] },
  { name: 'Push mower', short: 'MOW', color: '#70cbd3', speed: 61, range: 15, kinds: ['grass'] },
  { name: 'Riding mower', short: 'RIDE', color: '#f1ce69', speed: 96, range: 23, kinds: ['grass'] },
  { name: 'Leaf blower', short: 'BLOW', color: '#bc9ae8', speed: 67, range: 26, kinds: ['leaves', 'dirt'] },
];
export const LAWNS = [
  { x: 15, y: 132, w: 112, h: 78 }, { x: 173, y: 132, w: 112, h: 78 },
  { x: 15, y: 234, w: 48, h: 72 }, { x: 237, y: 234, w: 48, h: 72 },
];
const POINTS = { grass: 10, edge: 30, bush: 100, leaves: 80, dirt: 50 };
const WORK = { grass: .04, edge: .16, bush: .45, leaves: .32, dirt: .25 };
const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

export class LawnNinjas {
  constructor(random, finish) {
    this.random = random; this.finish = finish; this.level = 1; this.score = 0;
    this.time = 0; this.cleaned = 0; this.mischief = 0; this.over = false; this.tool = 1;
    this.player = { x: 150, y: 220, dx: 0, dy: -1 };
    this.particles = []; this.popups = []; this.shots = []; this.workSound = 0;
    this.newShift();
  }
  newShift() {
    this.remaining = Math.max(60, 110 - this.level * 8);
    this.jobs = []; this.stones = []; this.shots = []; this.particles = [];
    for (const lawn of LAWNS) {
      for (let y = lawn.y + 8; y < lawn.y + lawn.h - 3; y += 12) {
        for (let x = lawn.x + 8; x < lawn.x + lawn.w - 3; x += 12) this.jobs.push({ kind: 'grass', x, y, done: false, work: 0 });
      }
      for (let x = lawn.x + 10; x < lawn.x + lawn.w; x += 32) {
        this.jobs.push({ kind: 'edge', x, y: lawn.y + lawn.h - 2, done: false, work: 0 });
      }
    }
    for (const x of [29, 68, 107, 193, 232, 271]) this.jobs.push({ kind: 'bush', x, y: 123, done: false, work: 0 });
    for (let i = 0; i < 6; i++) {
      const lawn = LAWNS[i % LAWNS.length];
      this.jobs.push({ kind: 'leaves', x: lawn.x + 12 + this.random() * (lawn.w - 24), y: lawn.y + 18 + this.random() * (lawn.h - 35), done: false, work: 0 });
    }
    this.cars = [88, 129, 171, 212].map((x, i) => ({ x, y: 271, color: ['#c65a55', '#e1c66b', '#6d98bb', '#d4d4c1'][i], rock: false, dirt: false, honk: 0 }));
    for (const car of this.cars) {
      this.jobs.push({ kind: 'dirt', x: car.x + 8, y: 238, done: false, work: 0 });
      this.stones.push({ x: car.x - 6, y: 243, used: false });
    }
    this.totalJobs = this.jobs.length;
    this.player.x = 150; this.player.y = 220;
    this.message = this.level === 1 ? 'LOOK SHARP. LEAVE THE CARS QUESTIONABLE.' : `SHIFT ${this.level}! THE GRASS GREW BACK.`;
    this.messageTime = 4; this.progress = 0;
  }
  selectTool(index) { if (Number.isInteger(index) && TOOLS[index]) this.tool = index; }
  blocked(x, y) {
    if (x < 10 || x > 290 || y < 116 || y > 310) return true;
    return this.cars.some(c => Math.abs(x - c.x) < 16 && Math.abs(y - c.y) < 23);
  }
  popup(text, x, y, color = '#fff2a8') { this.popups.push({ text, x, y, color, life: 1.3 }); }
  burst(x, y, color, count = 6) {
    // Decorative particles use fixed directions, never the daily gameplay RNG.
    for (let i = 0; i < count; i++) {
      const angle = i * 2.399 + this.time;
      this.particles.push({ x, y, vx: Math.cos(angle) * 23, vy: Math.sin(angle) * 23 - 10, life: .4, color });
    }
  }
  hitCar(car, kind) {
    if (car[kind]) return;
    car[kind] = true; car.honk = .7; this.mischief++;
    const points = kind === 'rock' ? 150 : 200; this.score += points;
    this.popup(`${kind === 'rock' ? 'PING' : 'DUSTED'} +${points}`, car.x, car.y - 23, '#ffe483');
    this.message = kind === 'rock' ? 'CUSTOM PAINT JOB! +150' : 'COMPLIMENTARY DIRT DETAIL! +200';
    this.messageTime = 2.2; tone('hit'); this.burst(car.x, car.y, kind === 'rock' ? '#e5e3cd' : '#bd9068');
  }
  launch(kind, x, y) {
    this.shots.push({ kind, x, y, vx: this.player.dx * 145, vy: this.player.dy * 145, life: 1.1 });
  }
  work(dt) {
    const tool = TOOLS[this.tool], player = this.player;
    for (const job of this.jobs) {
      if (job.done || !tool.kinds.includes(job.kind) || distance(player, job) > tool.range) continue;
      job.work += dt;
      if (job.work < WORK[job.kind]) continue;
      job.done = true; this.cleaned++; this.score += POINTS[job.kind];
      if (job.kind !== 'grass') this.popup(`+${POINTS[job.kind]}`, job.x, job.y - 7);
      this.burst(job.x, job.y, job.kind === 'leaves' ? '#df9c4b' : '#c6e579', 4);
      if (job.kind === 'dirt') this.launch('dirt', job.x, job.y);
      if (this.workSound <= 0) { tone('clear'); this.workSound = .16; }
    }
    // Pebbles only fly toward the parking lot, so touch drags past them don't waste the shot.
    if (this.tool !== 3 && player.dy > .7) {
      for (const stone of this.stones) {
        if (!stone.used && distance(player, stone) < tool.range) {
          stone.used = true; this.launch('rock', stone.x, stone.y); tone('shot');
        }
      }
    }
  }
  update(dt, input) {
    if (this.over) return;
    this.time += dt; this.remaining -= dt; this.messageTime -= dt; this.workSound -= dt;
    if (this.remaining <= 0) {
      this.remaining = 0; this.over = true;
      this.finish({ score: this.score, level: this.level,
        detail: `${this.cleaned} jobs cleaned up • ${this.mischief} car bonuses • shift ${this.level}`,
        achievement: this.mischief >= 6 ? 'Parking lot menace' : this.level > 1 ? 'Master of the mow' : this.cleaned > 30 ? 'Grass assassin' : 'Apprentice of the lawn' });
      return;
    }
    const p = this.player;
    let dx = Number(!!input.right) - Number(!!input.left), dy = Number(!!input.down) - Number(!!input.up);
    if (input.pointer && input.targetX != null && input.targetY != null) {
      const tx = input.targetX / 2 - p.x, ty = input.targetY / 2 - p.y;
      const gap = Math.hypot(tx, ty);
      if (gap > 2) { dx = tx / gap; dy = ty / gap; }
    }
    const length = Math.hypot(dx, dy);
    this.moving = length > 0;
    if (length) {
      dx /= length; dy /= length; p.dx = dx; p.dy = dy;
      const speed = TOOLS[this.tool].speed * dt;
      if (!this.blocked(p.x + dx * speed, p.y)) p.x += dx * speed;
      if (!this.blocked(p.x, p.y + dy * speed)) p.y += dy * speed;
    }
    this.working = !!(input.shoot || input.pointer);
    if (this.working) this.work(dt);
    for (const shot of this.shots) {
      shot.x += shot.vx * dt; shot.y += shot.vy * dt; shot.life -= dt;
      const car = this.cars.find(c => Math.abs(shot.x - c.x) < 12 && Math.abs(shot.y - c.y) < 18);
      if (car && shot.life > 0) { this.hitCar(car, shot.kind); shot.life = 0; }
    }
    this.shots = this.shots.filter(s => s.life > 0);
    for (const car of this.cars) car.honk = Math.max(0, car.honk - dt);
    for (const particle of this.particles) { particle.x += particle.vx * dt; particle.y += particle.vy * dt; particle.life -= dt; }
    this.particles = this.particles.filter(particle => particle.life > 0);
    for (const popup of this.popups) { popup.y -= dt * 10; popup.life -= dt; }
    this.popups = this.popups.filter(popup => popup.life > 0);
    this.progress = this.jobs.filter(j => j.done).length / this.totalJobs;
    // Let in-flight pebbles and dirt land before the lot resets.
    if (this.progress === 1 && !this.shots.length) {
      const bonus = 500 + Math.ceil(this.remaining) * 10; this.score += bonus; this.level++;
      this.popup(`SHIFT CLEAR +${bonus}`, 150, 215); this.newShift(); tone('wave');
    }
  }
  draw(ctx, reduced) { drawLawn(ctx, this, reduced, TOOLS, LAWNS); }
}
